import React from 'react'
import './calculator.css'
import InterestCalculator from './InflationCalculator'  

const Header = () => {
    return (
        <React.Fragment>
            <InterestCalculator />
        </React.Fragment>
    )
}

export default Header